// extracted by mini-css-extract-plugin
export default {"wrap":"xt-z","fullWidth":"yt-z","items":"zt-z","featureCss":"At-z","disabled":"Bt-z","imgCss":"Ct-z"};